document.addEventListener('turbo:load', () => {
  // First check if we're on a page with the structure accordion
  const structureAccordion = document.getElementById('structureAccordion');
  if (!structureAccordion) return; // Exit early if the accordion doesn't exist
  
  // Get references to form fields
  const structureTypeCi2 = document.getElementById('structureTypeCi2');
  const structureIdCi2 = document.getElementById('structureIdCi2');
  const structureTypeLab = document.getElementById('structureTypeLab');
  const structureIdLab = document.getElementById('structureIdLab');
  const structureTypeResearchLine = document.getElementById('structureTypeResearchLine');
  const structureIdResearchLine = document.getElementById('structureIdResearchLine');
  
  if (!structureTypeCi2 || !structureIdCi2 || !structureTypeLab || 
      !structureIdLab || !structureTypeResearchLine || !structureIdResearchLine) {
    console.error("Required form elements missing");
    return;
  }
  
  // Find accordion headers and buttons
  const ci2Button = document.querySelector('#ci2Header .accordion-button');
  const labButton = document.querySelector('#labsHeader .accordion-button');
  const researchLineButton = document.querySelector('#researchLinesHeader .accordion-button');
  
  // Function to hide all checkmarks and show only the active one
  function showCheckmark(activeAccordion) {
    // Remove all checkmarks first
    const buttons = document.querySelectorAll('.accordion-button');
    buttons.forEach(button => {
      // Find and remove any existing checkmark in this button
      const existingCheckmark = button.querySelector('.checkmark-icon');
      if (existingCheckmark) {
        existingCheckmark.style.display = 'none';
      }
    });
    
    // Add checkmark to the active accordion
    if (activeAccordion === 'ci2Collapse' && ci2Button) {
      const checkmark = ci2Button.querySelector('.checkmark-icon');
      if (checkmark) checkmark.style.display = 'inline-block';
    } else if (activeAccordion === 'labsCollapse' && labButton) {
      const checkmark = labButton.querySelector('.checkmark-icon');
      if (checkmark) checkmark.style.display = 'inline-block';
    } else if (activeAccordion === 'researchLinesCollapse' && researchLineButton) {
      const checkmark = researchLineButton.querySelector('.checkmark-icon');
      if (checkmark) checkmark.style.display = 'inline-block';
    }
  }
  
  // Set the active structure fields (disable others)
  function setActiveStructure(type) {
    // First disable all fields
    structureTypeCi2.disabled = true;
    structureIdCi2.disabled = true;
    structureTypeLab.disabled = true;
    structureIdLab.disabled = true;
    structureTypeResearchLine.disabled = true;
    structureIdResearchLine.disabled = true;
    
    // Then enable and set values for the active structure
    if (type === 'ci2') {
      structureTypeCi2.disabled = false;
      structureIdCi2.disabled = false;
      structureTypeCi2.value = '';
      structureIdCi2.value = '';
    } else if (type === 'lab') {
      structureTypeLab.disabled = false;
      structureIdLab.disabled = false;
      structureTypeLab.value = 'Lab';
    } else if (type === 'researchLine') {
      structureTypeResearchLine.disabled = false;
      structureIdResearchLine.disabled = false;
      structureTypeResearchLine.value = 'ResearchLine';
    }
  }
  
  // Find accordion collapse elements
  const ci2Collapse = document.getElementById('ci2Collapse');
  const labsCollapse = document.getElementById('labsCollapse');
  const researchLinesCollapse = document.getElementById('researchLinesCollapse');
  
  // Add event listeners to detect when an accordion is shown
  if (ci2Collapse) {
    ci2Collapse.addEventListener('shown.bs.collapse', function() {
      console.log("CI2 accordion shown");
      showCheckmark('ci2Collapse');
      setActiveStructure('ci2');
    });
  }
  
  if (labsCollapse) {
    labsCollapse.addEventListener('shown.bs.collapse', function() {
      console.log("Labs accordion shown");
      showCheckmark('labsCollapse');
      setActiveStructure('lab');
    });
  }
  
  if (researchLinesCollapse) {
    researchLinesCollapse.addEventListener('shown.bs.collapse', function() {
      console.log("Research Lines accordion shown");
      showCheckmark('researchLinesCollapse');
      setActiveStructure('researchLine');
    });
  }
  
  // Setup select field change listeners
  const labSelect = document.getElementById('structureIdLab');
  if (labSelect) {
    labSelect.addEventListener('change', function() {
      structureIdLab.value = this.value;
    });
  }
  
  const researchLineSelect = document.getElementById('structureIdResearchLine');
  if (researchLineSelect) {
    researchLineSelect.addEventListener('change', function() {
      structureIdResearchLine.value = this.value;
    });
  }
  
  // Form validation
  const form = document.querySelector('form');
  if (form) {
    form.addEventListener('submit', function(event) {
      let activeType = null;
      let activeId = null;
      
      if (!structureTypeCi2.disabled) {
        activeType = structureTypeCi2;
        activeId = structureIdCi2;
      } else if (!structureTypeLab.disabled) {
        activeType = structureTypeLab;
        activeId = structureIdLab;
      } else if (!structureTypeResearchLine.disabled) {
        activeType = structureTypeResearchLine;
        activeId = structureIdResearchLine;
      }
      
      if ((activeType === structureTypeLab || activeType === structureTypeResearchLine) && 
          (!activeId.value || activeId.value === "")) {
        event.preventDefault();
        alert("Please select a specific option from the dropdown.");
        return false;
      }
    });
  }
  
  // Initialize based on which accordion is open on page load
  if (ci2Collapse && ci2Collapse.classList.contains('show')) {
    showCheckmark('ci2Collapse');
    setActiveStructure('ci2');
  } else if (labsCollapse && labsCollapse.classList.contains('show')) {
    showCheckmark('labsCollapse');
    setActiveStructure('lab');
  } else if (researchLinesCollapse && researchLinesCollapse.classList.contains('show')) {
    showCheckmark('researchLinesCollapse');
    setActiveStructure('researchLine');
  }
});